import React from 'react';
import { CurrencyOrEmpty } from '../../../components/typography/currency-or-empty.tsx';
import { DataText } from '../../../components/typography/data-text.tsx';
import { DeltaText } from '../../../components/typography/delta-text.tsx';
import { DeltaTriangle } from '../../../components/typography/delta-triangle.tsx';
import { NumberOrEmpty } from '../../../components/typography/number-or-empty.tsx';
import { PercentageOrEmpty } from '../../../components/typography/percentage-or-empty.tsx';
import { MaskedContent } from '../../customer-mode/components/masked-content.tsx';
import { DoubleDeckerCell } from './double-decker-cell.tsx';

export const DeltaDoubleDeckerCell = ({
    percentage,
    amount,
    masked = false,
    style = 'currency',
}: {
    percentage: number | null;
    amount: number | null;
    style?: 'currency' | 'number';
    masked?: boolean;
}) => {
    const up = amount === null || amount === 0 ? null : amount > 0;

    const Masked = masked ? MaskedContent : React.Fragment;
    const DataStyleComponent = style === 'currency' ? CurrencyOrEmpty : NumberOrEmpty;

    return (
        <DoubleDeckerCell
            topLevel={
                <Masked>
                    <DataText>
                        <DeltaText up={up}>
                            <PercentageOrEmpty showEmptyIfZero showPlusSignIfPositive>
                                {percentage}
                            </PercentageOrEmpty>
                            {up !== null && <DeltaTriangle up={up} />}
                        </DeltaText>
                    </DataText>
                </Masked>
            }
            bottomLevel={
                <Masked>
                    <DataText>
                        <DataStyleComponent showEmptyIfZero showPlusSignIfPositive>
                            {amount}
                        </DataStyleComponent>
                    </DataText>
                </Masked>
            }
        />
    );
};
